module.exports = __webpack_public_path__ + "static/media/newsfeed.058fd52d.svg";